module.exports = __webpack_public_path__ + "static/img/s1.ea2565f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s1.png
// module id = M+AU
// module chunks = 0